export enum TradeRestrictionReason {
  CDA = 'CDA',
  MNPI = 'MNPI',
  OTW = 'OTW',
  BOARD = 'BOARD',
  GENERAL = 'GENERAL',
}

export const TradeRestrictionReasonLabels: Record<TradeRestrictionReason, string> = {
  [TradeRestrictionReason.CDA]: 'CDA',
  [TradeRestrictionReason.MNPI]: 'MNPI',
  [TradeRestrictionReason.OTW]: 'OTW',
  [TradeRestrictionReason.BOARD]: 'Board',
  [TradeRestrictionReason.GENERAL]: 'General',
};
